/**
 * Created by Carsten Bühler
 * User: CBuehler on 28.04.2016
 * Copyright: xdot GmbH 2015
 */

import React from 'external/react';
import { Container, FormCheck, FormControl, FormGroup, FormLabel, Row } from 'external/react-bootstrap';
import { Title, ValidationMessage } from 'plugin/liferay-widgets-react-web';
import PropTypes from 'external/prop-types';

const FliwasFormGrid = ({ className = 'py-3', children }) => {
    return (
        <Container className={className}>{children}</Container>
    );
};

FliwasFormGrid.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};

const FliwasFormHeading = ({ title }) => (
    <Row className="row-2-col nomargin">
        <Title title={title}/>
    </Row>
);

FliwasFormHeading.propTypes = {
    title: PropTypes.string
};

const FliwasFormGroup = ({ title, formValidation, propName, formComponent, required = false, children }) =>
    <FormGroup className={(formValidation && formValidation[propName]) ? 'has-error' : ''}>
        {title && <FormLabel>{title + (required ? ' *' : '')}</FormLabel>}

        {children}

        {formValidation && <ValidationMessage formValidation={formValidation} propName={propName}/>}
    </FormGroup>;

FliwasFormGroup.propTypes = {
    title: PropTypes.string,
    formComponent: PropTypes.object,
    formValidation: PropTypes.object,
    propName: PropTypes.string,
    required: PropTypes.bool,
    children: PropTypes.node
};

const FliwasCheckbox = ({ name, onChange, label, checked, readOnly = false }) => {
    let cbProps = {};
    cbProps.checked = !!checked;
    return (
        <FormCheck
            type="checkbox"
            name={name}
            {...cbProps}
            onChange={onChange}
            readOnly={readOnly}
            label={label}
        />
    );
};

FliwasCheckbox.propTypes = {
    name: PropTypes.string,
    onChange: PropTypes.func,
    label: PropTypes.string,
    checked: PropTypes.bool,
    readOnly: PropTypes.bool,
};

const FliwasSelect = ({
    list, currentValue, onChange, disabled, hideDefaultOption = false,
    defaultOption = <option key={'option_'} value="">{'Bitte wählen!'}</option>
}) => {

    if (list.length === 0) {
        return <span>---</span>;
    }

    return (
        <FormControl
            as="select"
            value={currentValue}
            onChange={onChange}
            disabled={disabled}
        >
            {!hideDefaultOption && defaultOption}
            {
                list.map(({ value, label }) => (
                        <option
                            key={'option_' + label + '_' + value}
                            value={value}
                        >
                            {label}
                        </option>
                    )
                )
            }
        </FormControl>
    );
};

FliwasSelect.propTypes = {
    list: PropTypes.array,
    currentValue: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    hideDefaultOption: PropTypes.bool,
    defaultOption: PropTypes.node
};

export { FliwasFormGrid, FliwasSelect, FliwasCheckbox, FliwasFormGroup, FliwasFormHeading };



// WEBPACK FOOTER //
// ./js/components/BasicFormComponents.jsx